
import React, { useRef, useState } from 'react'
import useClickOutside from '@apex/lib/hooks/useClickOutside'
import useEscape from '@apex/lib/hooks/useEscape'
import Overlay from './Overlay'
import Box from './Box'

// TODO: close on escape

/**
 * Dialog component.
 */

export default Dialog

/**
 * Expose components.
 */

Dialog.Actions = Actions

/**
 * Dialog component.
 */

function Dialog({ onClose, onCloseComplete, children }) {
  const [animate, setAnimate] = useState("show")
  const ref = useRef(null)

  useClickOutside(ref, close)
  useEscape(close)

  function close() {
    setAnimate("hide")
    if (onClose) onClose()
    if (onCloseComplete) setTimeout(_ => onCloseComplete(), 200)
  }

  return <Overlay>
    <Box className="Dialog" animate={animate} innerRef={ref}>
      {typeof children == 'function'
        ? children({ close })
        : children}
    </Box>
  </Overlay>
}

/**
 * Actions component.
 */

function Actions({ children }) {
  return <div className="DialogActions">
    {children}
  </div>
}